import { getLocale, setUserLocale, buildLocalizedUrl } from "../../utilities/locale/locale";
import React, { useEffect, useState } from "react";
import "./LanguageSelectionButton.css";
import { Dropdown } from "primereact/dropdown";
import { useMediaQuery } from "react-responsive";
import { Button } from "primereact/button";

const LanguageSelectionButton = ({ storePage, storePageDropdown }) => {
  const [language, setLanguage] = useState(null);

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const languages = [
    { label: "PT", iso639: "pt", fullLabel: "Português" },
    { label: "IT", iso639: "it", fullLabel: "Italiano" },
    { label: "ES", iso639: "es", fullLabel: "Español" },
    { label: "EN", iso639: "en", fullLabel: "English" },
  ];

  useEffect(() => {
    switch (getLocale()) {
      case "pt":
        setLanguage({ label: "PT", iso639: "pt", fullLabel: "Português" });
        break;
      case "it":
        setLanguage({ label: "IT", iso639: "it", fullLabel: "Italiano" });
        break;
      case "es":
        setLanguage({ label: "ES", iso639: "es", fullLabel: "Español" });
        break;
      default:
        setLanguage({ label: "EN", iso639: "en", fullLabel: "English" });
        break;
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
    setUserLocale(newLanguage.iso639);
    window.location.href = buildLocalizedUrl(newLanguage.iso639);
  };

  if (storePage && isMobile) return null;

  if (!isMobile || storePage) {
    return (
      <div className="flex align-items-center language-dropdown-wrapper border-round">
        <div className="language-dropdown">
          <Dropdown
            className="text-center p-no-outline"
            panelClassName="language-dropdown-panel"
            value={language}
            options={languages}
            onChange={(e) => handleLanguageChange(e.value)}
            valueTemplate={(option) =>
              storePage ? (
                <i className="pi pi-globe"></i>
              ) : option ? (
                <span>{option.label}</span>
              ) : (
                <span>--</span>
              )
            }
            itemTemplate={(option) => <span>{option.fullLabel}</span>}
            optionLabel="label"
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="flex align-items-center language-button-wrapper border-round gap-2">
        {languages.map((lang, index) => (
          <React.Fragment key={lang.iso639}>
            <Button
              link
              className={`text-white uppercase ${
                language && language.iso639 === lang.iso639 ? "font-semibold" : ""
              }`}
              onClick={() => handleLanguageChange(lang)}
              style={storePageDropdown && index === 0 ? { paddingLeft: 0 } : {}}
            >
              {language && language.iso639 === lang.iso639 ? lang.fullLabel : lang.label}
            </Button>
            {index < languages.length - 1 && <span style={{ color: "#4ED372" }}>|</span>}
          </React.Fragment>
        ))}
      </div>
    );
  }
};

export default LanguageSelectionButton;
